import { render } from "./WaitList.vue?vue&type=template&id=fa692a12"
import script from "./WaitList.vue?vue&type=script&lang=js"
export * from "./WaitList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AlterLau\\walter-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__